import React from "react";
import { StaticQuery, graphql } from "gatsby";
import TitleContentPage from "../components/title-content-page";

const AboutUs = () => (
  <StaticQuery
    query={graphql`
      query aboutUsQuery {
        allPrismicAboutUs(limit: 1) {
          nodes {
            data {
              content {
                html
              }
              title {
                text
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const { content, title } = data.allPrismicAboutUs.nodes[0].data;
      return <TitleContentPage title={title.text} content={content.html} />;
    }}
  />
);

export default AboutUs;
